import { useNavigate } from "react-router-dom";
import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "../../config";
import "../PageCommon.css";
import "./Dashboard.css";
import RecordTable from "../../components/Record/RecordTable";
import Button from 'react-bootstrap/Button';

const DashboardPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
      if (!localStorage.getItem('token')) {
        navigate('/signin');
      }
  }, [navigate]);

  const [error, setError] = useState(null);

  const createNewAnalysis = () => {
    const user_id = localStorage.getItem('user_id');
    const userName = localStorage.getItem('user');
    
    axios.post(`${config.apiUrl}/api/experiment/`, {
      user_id: user_id,
      user: userName
    })
    .then(response => {
        let url_id = response.data.id;
        if (response.status === 201 && url_id) {
          navigate(`/pavement-context-basic/${url_id}`);
        }
    })
    .catch(error => {
        setError(error.message);
    });
  };

  if (error) console.log(error);

  return (
    <div className="page__container">
      <div className="page__head" style={{ alignItems: "end" }}>
      <Button variant="primary" onClick={createNewAnalysis}>New Experiment</Button>
      </div>
      <div className="page__body">
        <RecordTable />
        
      </div>
    </div>
  );
};

export default DashboardPage;